"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainLinkSetSubscriptionButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const types_1 = require("@framework/types");
const styled_1 = require("@framework/styled");
const setSubscriptionId_json_1 = __importDefault(require("@framework/abis/json/ERC721RandomGemunion/setSubscriptionId.json"));
const dialogs_1 = require("../../../../dialogs");
const ChainLinkSetSubscriptionButton = (props) => {
    const { className, disabled, contract: { address, contractModule, contractFeatures, accessControls }, contract, variant = styled_1.ListActionVariant.button, } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const hasPermission = accessControls.some(item => item.role === types_1.AccessControlRoleType.DEFAULT_ADMIN_ROLE);
    const { execute: metaFnSetSub } = (0, react_hooks_eth_1.useMetamask)(async (options) => {
        // https://docs.chain.link/docs/link-token-contracts/
        const uintSub = BigInt(options.vrfSubId.substring(0, options.vrfSubId.length));
        return writeContractAsync({
            address: address,
            abi: setSubscriptionId_json_1.default,
            functionName: "setSubscriptionId",
            args: [uintSub],
        });
    });
    if (contractModule === types_1.ModuleType.HIERARCHY &&
        !(contractFeatures.includes(types_1.ContractFeatures.RANDOM) || contractFeatures.includes(types_1.ContractFeatures.GENES))) {
        return null;
    }
    const handleSetSubscriptionConfirm = async ({ data, }) => {
        await metaFnSetSub(data);
    };
    const handleSetSubscription = () => {
        openDialog(dialogs_1.GlobalDialogKeys.SET_CHAIN_LINK_SUBSCRIPTION, contract, {
            initialValues: {
                vrfSubId: "0n",
            },
            message: "dialogs.vrfSetSub",
            testId: "ChainLinkSetSubscriptionDialog",
            onExternalConfirm: handleSetSubscriptionConfirm,
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleSetSubscription, icon: icons_material_1.Subscriptions, message: "pages.chain-link.set", className: className, dataTestId: "ChainLinkSetSubscriptionButton", disabled: disabled || !hasPermission, variant: variant }));
};
exports.ChainLinkSetSubscriptionButton = ChainLinkSetSubscriptionButton;
//# sourceMappingURL=index.js.map